import { Get, getAPIUrl, Post } from "../../ApiServices/apiMethod";


export const AviatorEndpoints = {
  placeBet: "aviator/betting",
  aviatorPlayHistory: "aviator/aviatorPlayHistory",
  latestBets: "aviator/latestBets",
  topBets: "aviator/fetchTopBets",
};

export const PlaceBet = (data, param = "") => {
  const url = getAPIUrl(AviatorEndpoints.placeBet, param);
  return Post(url, data);
};
export const AviatorPlayHistory = (data, param = "") => {
  const url = getAPIUrl(AviatorEndpoints.aviatorPlayHistory, param);
  return Get(url, data);
};
export const LatesBets = (param = "") => {
  const url = getAPIUrl(AviatorEndpoints.latestBets, param);
  return Get(url);
};
export const TopBets = (param = "") => {
  const url = getAPIUrl(AviatorEndpoints.topBets, param);
  return Get(url);
};
